"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImageSizes = exports.ImageRatios = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _placeholder = _interopRequireDefault(require("../../../../assets/images/placeholder.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    box: {
      height: 0,
      width: "100%",
      backgroundColor: theme.palette.grey[200]
    },
    overlay: {
      position: "relative",
      "&:before": {
        content: "''",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: (0, _core.fade)(theme.palette.primary.main, 0.4)
      }
    },
    rounded: {
      borderRadius: 6,
      "&:before": {
        borderRadius: 6
      }
    },
    "16x9": {
      paddingTop: "calc(9/16*100%)"
    },
    "4x3": {
      paddingTop: "calc(3/4*100%)"
    },
    "1x1": {
      paddingTop: "calc(100%)"
    },
    full: {
      width: "100%"
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      padding: 0
    },
    medium: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      padding: 0
    },
    large: {
      width: theme.spacing(4.5),
      height: theme.spacing(4.5),
      padding: 0
    },
    xlarge: {
      width: theme.spacing(62.5),
      height: theme.spacing(62.5),
      padding: 0
    }
  };
});
/**
 * ** Imagery communicates and differentiates a product through visuals. **
 *
 * ** Focal point (Aspect ratio) **
 *
 * Creating a focal point will determine how the image should be cropped. An aspect ratio is the proportion of an element’s width to its height. Aspect ratios are written as width:height. To maintain consistency in your layout, use a consistent aspect ratio on elements like images illustrations. The following aspect ratios are recommended for use across your UI: 16:9, 1:1 and 3:4.
 *
 * ** Colour Overlay **
 *
 * When you want the content to be the focus a colour overlay image can be used:
 *
 * -  Place the content above the base red colour #E60000
 *
 * - Set it’s blending mode to multiply
 *
 * - Set the image to 40% opacity for the desired result
 *
 * ** Image placeholder **
 *
 * An image placeholder is a dummy image designed to draw attention to the need for an actual image.
 */

var Image = function Image(_ref) {
  var _classNames;

  var src = _ref.src,
      size = _ref.size,
      ratio = _ref.ratio,
      hasOverlay = _ref.hasOverlay,
      isRounded = _ref.isRounded,
      isPlaceholder = _ref.isPlaceholder;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    image: src || _placeholder.default,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.box, true), _defineProperty(_classNames, styles[ratio], true), _defineProperty(_classNames, styles[size], isPlaceholder), _defineProperty(_classNames, styles.overlay, hasOverlay), _defineProperty(_classNames, styles.rounded, isRounded), _classNames))
  });
};

Image.propTypes = {
  /** The url of the image (if null will apply placeholder image) */
  src: _propTypes.default.string,

  /** The aspect ratio of the image */
  ratio: _propTypes.default.oneOf(["16x9", "4x3", "1x1"]),

  /** The size of the image used with isPlaceholder property in combination (100%, 24px, 32px, 36px, 500px) */
  size: _propTypes.default.oneOf(["full", "small", "medium", "large", "xlarge"]),

  /** The image to work as placeholder element */
  isPlaceholder: _propTypes.default.bool,

  /** Red overlay on the image */
  hasOverlay: _propTypes.default.bool,

  /** Rounded corners works */
  isRounded: _propTypes.default.bool
};
Image.defaultProps = {
  src: null,
  ratio: "1x1",
  hasOverlay: false,
  isRounded: false,
  isPlaceholder: false,
  size: "full"
};
var ImageRatios = ["16x9", "4x3", "1x1"];
exports.ImageRatios = ImageRatios;
var ImageSizes = ["full", "small", "medium", "large", "xlarge"];
exports.ImageSizes = ImageSizes;
var _default = Image;
exports.default = _default;